import React, { useMemo, useEffect, useRef } from "react";
import { useGetUserInfoQuery } from "../../services/apiSlice";
import Dialog from "../common/Dialog";
import OnboardingModal from "./OnboardingModal";
import { WAITLIST_DATA } from "./onboardingData";

const GlobalGuideManager = () => {
  const dialogRef = useRef(null);

  const token =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");

  const { data: userInfoData, isLoading } = useGetUserInfoQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: !token,
  });

  const userInfo = userInfoData?.data || userInfoData;

  const shouldShowGlobalPopup = useMemo(() => {
    if (!token || isLoading || !userInfo?.id) return false;

    return userInfo.guide_one_status === "NEED";
  }, [userInfo, isLoading, token]);

  useEffect(() => {
    if (shouldShowGlobalPopup && dialogRef.current) {
      dialogRef.current.open();
    }
  }, [shouldShowGlobalPopup]);

  if (!shouldShowGlobalPopup) return null;

  return (
    <Dialog
      ref={dialogRef}
      hiddenCloseButton={true}
      className="!p-0 !max-w-[340px] !rounded-[20px]"
    >
      <OnboardingModal config={WAITLIST_DATA} onClose={() => {}} />
    </Dialog>
  );
};

export default GlobalGuideManager;
